import { TypographySmall } from '@talentmesh/ui/components/typography';
import {
    characteristicColClass,
    importanceColClass,
    progressColClass,
    scoreColClass,
} from './PersonalityCharacteristicConsts';
import UIStrings from '@/Utils/UIStrings';

function PersonalityCharacteristicHeader() {
    return (
        <>
            <div className={`${characteristicColClass} pb-2`}>
                <TypographySmall className="text-muted-foreground text-xs">{UIStrings.Characteristic}</TypographySmall>
            </div>
            <div className={scoreColClass}>
                <TypographySmall className="text-muted-foreground text-xs">{UIStrings.Score}</TypographySmall>
            </div>
            <div className={progressColClass} />
            <div className={importanceColClass}>
                <TypographySmall className="text-muted-foreground text-xs">{UIStrings.Importance}</TypographySmall>
            </div>
        </>
    );
}

export default PersonalityCharacteristicHeader;
